import { motion } from "framer-motion";
import { Blocks, ServerCog, Code2, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Blocks,
    title: "Minecraft Plugins",
    description: "Custom plugins and server features built for performance, stability, and your exact needs.",
    testid: "service-card-minecraft-plugins",
  },
  {
    icon: ServerCog,
    title: "Server Solutions",
    description: "Configuration, optimization, and setup assistance to keep your server running at its best.",
    testid: "service-card-server-solutions",
  },
  {
    icon: Code2,
    title: "Development Services",
    description: "Tailored development solutions for Minecraft communities, from tools to integrations.",
    testid: "service-card-development-services",
  },
];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

const card = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.21, 0.65, 0.35, 1] },
  },
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 lg:py-28 border-t border-purple-500/10"
    >
      <div
        className="absolute top-0 right-0 w-[600px] h-[400px] pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(147,51,234,0.12) 0%, rgba(9,10,15,0) 70%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-14"
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-purple-400 mb-4">
            Our Services
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white leading-tight">
            What we build for you
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-400">
            Focused expertise across every layer of your Minecraft server.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {SERVICES.map((service) => (
            <motion.div
              key={service.title}
              variants={card}
              data-testid={service.testid}
              className="group relative h-full rounded-2xl border border-purple-500/15 bg-[#11131f]/80 p-8 transition-all duration-300 hover:border-purple-500/50 hover:-translate-y-1.5 hover:shadow-[0_16px_50px_rgba(147,51,234,0.18)]"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-purple-500/25 bg-purple-500/10 transition-colors duration-300 group-hover:bg-purple-500/20">
                <service.icon className="w-6 h-6 text-purple-400" />
              </span>
              <h3 className="mt-6 text-xl font-semibold text-white">
                {service.title}
              </h3>
              <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">
                {service.description}
              </p>
              <ArrowUpRight className="absolute top-8 right-8 w-5 h-5 text-purple-500/40 transition-all duration-300 group-hover:text-purple-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
